
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 3.333A6.66 6.66 0 004.487 6.25h2.18v1.667h-5v-5h1.666v2.082a8.333 8.333 0 0115 5h-1.666A6.667 6.667 0 0010 3.334zM3.333 10a6.667 6.667 0 0012.18 3.75h-2.18v-1.667h5v5h-1.666v-2.082a8.333 8.333 0 01-15-5h1.666z","fill":"#910000"}})])
          )
        }
      }
    